(() => {
  function init() {
    const proof = document.querySelector('[data-home-proof]');
    if (!proof) return;
    const copy = () => {
      const widget = document.querySelector('.jdgm-cards-carousel');
      if (!widget) return false;
      const heading = widget.querySelector('.jdgm-title') || widget;
      heading.id = 'HomeReviews';
      const source = widget.querySelector('.jdgm-average-rating .jdgm-rating-text');
      const target = proof.querySelector('[data-home-rating]');
      const rating = source?.textContent?.replace(/\s+/g, ' ').trim() || '';
      if (target.textContent !== rating) target.textContent = rating;
      target.hidden = !rating;
      proof.hidden = false;
      return !!rating;
    };
    if (copy()) return;
    const observer = new MutationObserver(() => { if (copy()) observer.disconnect(); });
    observer.observe(document.body, { childList: true, subtree: true, characterData: true });
    window.setTimeout(() => observer.disconnect(), 15000);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
  document.addEventListener('shopify:section:load', init);
})();
